import { render, staticRenderFns } from "./assessment-mobile.vue?vue&type=template&id=2711ca39&scoped=true&"
import script from "./assessment-mobile.vue?vue&type=script&lang=ts&"
export * from "./assessment-mobile.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-mobile.vue?vue&type=style&index=0&id=2711ca39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2711ca39",
  null
  
)

export default component.exports